<template>
  <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="close"
  >
    <v-card style="max-height: 400px">
      <v-toolbar dark class="log-header" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-white">{{ $t('ID события:') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4 text-black">
        <div v-if="loading">{{ $t('Загрузка данных...') }}</div>
        <div v-else class="data-block" style="max-width: 480px;">
          <pre style="white-space: pre-wrap; word-break: break-word;">{{ data.eventMessage }}</pre></div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            variant="text"
            class="exitButton"
            @click.native="close"
        >{{ $t('Закрыть') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';

export default {
  name: 'InfoDlg',
  data() {
    return {
      dialog: false,
      title: null,
      data: null,
      loading: false,
      options: {
        width: 500,
        zIndex: 200,
      },
    };
  },

  methods: {
    async open(id) {
      this.dialog = true;
      this.title = id;
      this.loading = true;
      this.data = await api.get(`/api/event/${id}`);
      this.loading = false;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style>
.data-block {
  font-family: var(--primary-font-family-name);
  font-size: 14px;
}

.log-header {
  background-color: rgb(var(--intec-primary-color));
}

.exitButton {
  border-radius: 6px;
  border: 1px solid rgb(var(--intec-primary-color));
  color: rgb(var(--intec-primary-color));
  background-color: transparent;
  font-family: var(--primary-font-family-name);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
}
</style>